import { observer } from 'mobx-react-lite'
import { Button, Icon, type ITooltipProps } from 'shared/ui'
import { AddOnCard } from 'pages/settings/ui/AddOnCard/AddOnCard'
import { useAddOnsViewContext } from 'pages/settings/pages/addOns/context/addOnsViewContext'
import styles from './styles.module.scss'

export const TrustedCalling = observer(() => {
  const store = useAddOnsViewContext()
  const isActive = store.entities.billingStore.billingComplianceInfo?.subscribed ?? false
  const tooltipProps: ITooltipProps | undefined = isActive
    ? {
        label: 'To disable this add-on, please reach out to our team.',
        desc: (
          <Button
            text='Contact support'
            typeBtn='link'
            paddingInline={0}
            style={{ paddingBlock: 0 }}
            onClick={store.trustedCallingOnContactSupportClick}
          />
        ),
        type: 'description',
        placement: 'top',
        maxWidth: 350,
      }
    : undefined

  return (
    <AddOnCard
      icon='phoneCheck'
      isActive={isActive}
      isSwitchDisabled={isActive}
      showSwitch={isActive}
      title='Trusted Calling'
      price={store.trustedCallingPriceText ?? ''}
      tooltipProps={tooltipProps}
      description='Improves answer rates, brand recognition, and trust. Registration is required.'
      titleAdditionalContent={
        <>
          <Icon className={styles.flagUSA} icon='flagUSA' fontSize={20} />
          <Icon className={styles.flagCanada} icon='flagCanada' fontSize={20} />
        </>
      }
      onSeeDetailsClick={store.openCallingAddOnModal}
      onActionClick={store.trustedCallingOnActionClick}
    />
  )
})
